import { jwtDecode } from 'jwt-decode';
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../Styles/AppBar.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBars, faSignOutAlt, faChartBar, faMoneyBill, faFileInvoice, faUpload,
  faUserFriends, faUniversity, faCalendarAlt, faFileAlt, faUser
} from '@fortawesome/free-solid-svg-icons';

const AppBar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [walletBalance, setWalletBalance] = useState(null);
  const [userName, setUserName] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null); // <-- State for phoneNumber

  const navigate = useNavigate();

  useEffect(() => {
    const tokenData = localStorage.getItem('b2bAuthToken');
    if (tokenData) {
      try {
        const parsedData = JSON.parse(tokenData);
        const token = parsedData.token;
        const decodedPayload = jwtDecode(token);
        const userId = decodedPayload.id;
        fetchWalletBalance(userId);
      } catch (error) {
        console.error('Error parsing token data:', error);
      }
    } else {
      console.error('No token data found in localStorage');
    }
  }, []);

  const fetchWalletBalance = async (id) => {
    try {
      const response = await fetch(`https://b2bdubaibackendapi.mmstourism.com/api/b2/b2b.rou.g5c6y4/a1b1c1d16/${id}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const data = await response.json();
        setWalletBalance(data.data.wallet || '0');
        setUserName(data.data.fullName);
        setPhoneNumber(data.data.phoneNumber); // <-- Set phoneNumber in state
        console.log("Phone number of agency is", data.data.phoneNumber);
      } else {
        console.error('Failed to fetch wallet balance:', response.statusText);
      }
    } catch (error) {
      console.error('Error fetching wallet balance:', error);
    }
  };

  const toggleMenu = () => setMenuOpen(!menuOpen);

  useEffect(() => {
    const closeMenu = (e) => {
      if (!e.target.closest('.navbar')) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('click', closeMenu);
    return () => document.removeEventListener('click', closeMenu);
  }, []);
  return (
    <div className="navbar">
      {/* App Title */}
      <h3 className="appbar-title" onClick={() => navigate(`/flightSearch`)}>
        MMSTourism
      </h3>

      {/* Right Side Buttons */}
      <div className="right-side-buttons">
        {/* Pax Calendar Button */}
        <button className="right-side-button" onClick={() => navigate(`/airpaxcalendar`)}>
          <FontAwesomeIcon icon={faCalendarAlt} />
          <span>Pax Calendar</span>
        </button>

        {/* Wallet Dropdown */}
        <div className="relative inline-block">
          <select
            className="wallet-dropdown px-4 py-2 right-side-button"
            onChange={(e) => navigate(e.target.value)}
            defaultValue="wallet"
          >
            <option value="wallet" disabled>
              Wallet Balance AED{walletBalance}
            </option>
            <option value="/recharge">Add Balance</option>
          </select>
        </div>

      </div>

      {/* Menu Icon */}
      <FontAwesomeIcon className="icon-style" icon={faBars} onClick={toggleMenu} />

      {/* Sidebar Menu */}
      {menuOpen && (
        <div className="sidebar-menu">
          <div className="sidebar-title">{userName}</div>
          <div className="menu-items">
            <div className="menu-item">
              <FontAwesomeIcon icon={faChartBar} onClick={() => {navigate(`/solidticket`);setMenuOpen(false)}} />
              <span>Sales Record</span>
            </div>
            {/* <div className="menu-item">
              <FontAwesomeIcon icon={faFileInvoice} onClick={() => {navigate(`/account`); setMenuOpen(false)}} />
              <span>Accounts Ledger</span>
            </div> */}
                   <div className="menu-item" onClick={() => {
  const tokenData = localStorage.getItem('b2bAuthToken');
  const token = tokenData ? JSON.parse(tokenData).token : null;
  const decoded = token ? jwtDecode(token) : null;
  const agentId = decoded?.id;

  if (agentId) {
    navigate('/account', { state: { agentId } }); // ✅ pass as state
  }

  setMenuOpen(false);
}}>
  <FontAwesomeIcon icon={faFileInvoice} />
  <span>Accounts Ledger</span>
</div>

           
            <div className="menu-item">
              <FontAwesomeIcon icon={faUniversity} onClick={() => {navigate(`/bank_details`);setMenuOpen(false)}} />
              <span>Bank Details</span>
            </div>
            {/* <div className="menu-item">
              <FontAwesomeIcon icon={faUserFriends} onClick={() => {navigate(`/group_query`);setMenuOpen(false)}} />
              <span>Group Query</span>
            </div> */}
            <div className="menu-item">
              <FontAwesomeIcon icon={faCalendarAlt} onClick={() => {navigate(`/airpaxcalendar`); setMenuOpen(false)}} />
              <span>Pax Calendar</span>
            </div>
            <div className="menu-item">
              <FontAwesomeIcon icon={faFileAlt} onClick={() => {navigate(`/recharge`);setMenuOpen(false)}} />
              <span>Online Recharge</span>
            </div>
            {/* <div 
    className="profile-link"
    onClick={() => {
      const tokenData = localStorage.getItem('b2bAuthToken');
      const token = tokenData ? JSON.parse(tokenData).token : null;
      const decoded = token ? jwtDecode(token) : null;
      const agentId = decoded?.id;

      if (agentId) {
        navigate('/profile', { state: { agentId } }); // ✅ go to profile page
      }
      setMenuOpen(false);
    }}
  >
    Profile
  </div> */}
  <div
  className="menu-item"
  onClick={() => {
    const tokenData = localStorage.getItem("b2bAuthToken");
    const token = tokenData ? JSON.parse(tokenData).token : null;
    const decoded = token ? jwtDecode(token) : null;
    const agentId = decoded?.id;

    if (agentId) {
      navigate("/profile", { state: { agentId } }); // ✅ go to profile page
    }
    setMenuOpen(false);
  }}
>
  <FontAwesomeIcon icon={faUser} /> {/* ✅ profile icon */}
  <span>Profile</span>
</div>
          </div>
          <div className="footer1">
             {phoneNumber && (
              <Link to="/change-password" state={{ phoneNumber }}>
                Change Password
              </Link>
            )}
            
            {/* <Link to="/change-password">Change Password</Link> */}
            <Link to="/" className="logout-link">
              <FontAwesomeIcon icon={faSignOutAlt} /> Logout
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default AppBar;
